import { makeStyles } from "@mui/styles";
import Theme from "../../themes/theme";
const SPACE_BETWEEN = "space-between";
const FONT_SIZE_16 = "16px !important";

export default makeStyles((theme: Theme) => {
  return {
    tableToolbar: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      backgroundColor: theme.palette.UI.white,
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    tableHead: {
      borderTop: "1px solid rgba(224, 224, 224, 1)",
    },
    tableHeader: {
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: 16,
      lineHeight: "21px",
      color: theme.palette.UI.grey_800,
      margin: "16px 0 8px 16px",
    },
    filterContainer: {
      marginLeft: "16px",
      border: `1px solid ${theme.palette.UI.black_300}`,
      width: "130px",
      height: "20px",
      borderRadius: "4px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "13px",
    },
    divider: {
      margin: "8px 16px 0 16px",
      border: `1px solid ${theme.palette.UI.grey_100}`,
    },
    countDisplay: {
      fontWeight: "normal",
      color: theme.palette.UI.blue_80,
    },
    activeAccordion: {
      backgroundColor: theme.palette.UI.grey_100,
      minHeight: "44px !important",
      height: "44px !important",
    },
    addNewuserButton: {
      width: "auto",
      height: "21px",
      fontSize: "13px",
      textTransform: "none",
      color: `${theme.link.color} !important`,
      backgroundColor: "transparent !important",
      "&:hover": {
        backgroundColor: theme.palette.UI.white,
      },
    },
    dataTableHeader: {
      color: theme.palette.UI.grey_700,
    },
    activeLabel: {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: "bold !important",
    },
    searchInput: {
      paddingLeft: 15,
    },
    unselectedMenuItem: {
      color: theme.palette.UI.blue_80,
      fontSize: "14px",
    },
    heading: {
      fontSize: 14,
      color: theme.palette.UI.black,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
      },
    },
    cellContent: {
      marginLeft: "10px",
    },
    drawer: {
      borderTop: `1px solid ${theme.palette.UI.grey}`,
      top: 64,
      width: 400,
    },
    drawerRoot: {
      width: 400,
    },
    fixedHeader: {
      position: "fixed",
      width: 400,
      zIndex: 1,
      backgroundColor: "white",
    },
    drawerContent: {
      width: 400,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    filterDropdown: {
      width: "315px",
      border: "1px solid #606060",
      boxSizing: "border-box",
      borderRadius: "4px",
      textTransform: "none",
    },
    drawerHeader: {
      display: "flex",
      flexRow: "row wrap",
      justifyContent: SPACE_BETWEEN,
      // necessary for content to be below app bar
      // ...theme.mixins.toolbar,
    },
    closeButton: {
      textAlign: "right",
    },
    resetButton: {
      color: theme.palette.UI.grey_700,
      textAlign: "center",
      fontSize: FONT_SIZE_16,
      textTransform: "none",
      "&:hover": {
        backgroundColor: theme.palette.UI.white,
      },
    },
    backButton: {
      textAlign: "left",
      color: theme.palette.UI.grey_900,
      fontSize: FONT_SIZE_16,
      textTransform: "none",
      "&:hover": {
        backgroundColor: theme.palette.UI.white,
      },
    },
    iconContainer: {
      // justifyContent: "space-evenly",
      display: "flex",
      minWidth: "40px",
      visibility: "hidden",
    },
    iconButton: {
      border: `1px solid ${theme.palette.UI.grey}`,
      borderRadius: "4px",
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    addIconButton: {
      borderRadius: "4px",
      padding: theme.spacing(1),
      marginLeft: 4,
      "&:hover": {
        cursor: "pointer",
      },
      "&:active": {
        "& path": {
          fill: theme.palette.UI.purple_600,
        },
      },
    },
    addIconButtonActive: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      cursor: "pointer",
      "&:active": {
        "& path": {
          fill: `${theme.palette.UI.purple_600}!important`,
        },
      },
    },
    filterEnterpriseIconButton: {
      border: `1px solid ${theme.palette.UI.grey}`,
      borderRadius: "4px",
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      "&:hover": {
        cursor: "pointer",
        backgroundColor: theme.palette.UI.dark_rose,
      },
    },
    editIconButton: {
      borderRadius: "4px",
      padding: theme.spacing(1),
      "&:hover": {
        cursor: "pointer",
      },
      "&:active": {
        "& path": {
          fill: `${theme.palette.UI.purple_600}!important`,
        },
      },
    },

    editIconButtonActive: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      cursor: "pointer",
    },
    marginLeft: {
      marginLeft: theme.spacing(1),
    },
    additionalButton: {
      border: `1px solid ${theme.button.outlined.color.primary}`,
      padding: "6px, 14px, 6px, 14px",
      marginLeft: theme.spacing(1),
      color: `${theme.palette.UI.white} !important`,
      textTransform: "none",
      fontSize: "16px",
      height: "36px",
      "&:hover": {
        backgroundColor: theme.button.contained.background.hover,
        border: `1px solid ${theme.button.outlined.background.hover}`,
      },
    },
    icon: {
      width: "18px",
      height: "18px",
    },
    columnIcon: {
      padding: theme.spacing(1),
    },
    columnIconActive: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      cursor: "pointer",
    },
    iconActive: {
      "& path": {
        fill: `${theme.palette.UI.purple_600}!important`,
      },
    },
    userIcon: {
      padding: theme.spacing(0.5),
    },
    counterDiv: {
      borderRadius: "20px",
      backgroundColor: "#EBEBEB",
      width: "30px",
      textAlign: "center",
    },
    centerContent: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modalHeader: {
      display: "flex",
      flexRow: "row wrap",
      justifyContent: SPACE_BETWEEN,
    },
    saveButton: {
      background: theme.palette.UI.pink,
      marginLeft: "20px",
    },
    modalFooter: {
      paddingTop: "20px",
    },
    quickFilterTitle: {
      fontSize: "14px !important",
      color: theme.palette.text.placeholder_text,
      cursor: "pointer",
    },
    quickFilterItemBox: {
      "&:hover": {
        backgroundColor: "#4D4D4D",
      },
      "&:hover $counterDiv": {
        color: "#333333",
        backgroundColor: "#FFFFFF",
        borderRadius: "40px",
      },
      "&:hover $quickFilterTitle": {
        color: "#FFFFFF",
      },
      "&:hover $filterCheckBox": {
        color: "#FFFFFF !important",
      },
    },
    filterCheckBox: {
      color: "#333333 !important",
    },
    quickFilterLabel: {
      maxWidth: "25ch",
      overflowX: "hidden",
      textOverflow: "ellipsis",
    },
    filterLabelTooltip: {
      background: theme.palette.UI.grey_900,
      fontSize: 14,
      borderRadius: 4,
    },
    tooltipArrow: {
      color: theme.palette.UI.grey_900,
    },
    tagTooltip: {
      background: theme.palette.UI.grey_800,
      marginTop: "0px !important",
      marginLeft: 14,
    },
    tagPopper: {
      marginLeft: "-36px !important",
      background: theme.palette.UI.grey_800,
      borderRadius: 4,
    },
    tag: {
      background: theme.palette.UI.grey_700,
      color: theme.palette.UI.white,
      margin: 1,
    },
    tagCancel: {
      color: `${theme.palette.UI.white} !important`,
    },
    accordionTitle: {
      fontSize: 14,
      color: theme.palette.UI.grey_900,
      fontWeight: 900,
    },
    accordionCount: {
      paddingLeft: theme.spacing(2),
      marginLeft: theme.spacing(2),
      borderLeft: "1px solid #D1D1D1",
      fontSize: 14,
      color: theme.palette.UI.blue_80,
    },
    accordion: {
      boxShadow: "none",
    },
    suspend: {
      maxWidth: "100px",
      borderRadius: 40,
      padding: "2px 8px",
      minWidth: 35,
      minHeight: 24,
      maxHeight: 24,
      boxShadow: "none",
      fontSize: 14,
    },
    suspendYes: {
      background: `${theme.palette.UI.background} !important`,
      color: `${theme.palette.text.warning} !important`,
      textTransform: "capitalize",
    },
    suspendNo: {
      minWidth: "32px !important",
      background: `${theme.palette.background.success} !important`,
      color: `${theme.palette.text.success} !important`,
      textTransform: "capitalize",
    },
    deleteContainer: {
      minHeight: 170,
    },
    deleteIcon: {
      width: 50,
      height: 50,
      borderRadius: "100%",
    },
    deleteIconContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#eee",
      width: 100,
      height: 100,
      borderRadius: "100%",
    },
    statusEditContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: SPACE_BETWEEN,
      width: "auto",
      "& :hover": {
        color: "none",
        cursor: "pointer",
        "& .statusChangeIconButton": {
          display: "flex",
        },
      },
    },
    statusButton: {
      minWidth: 11,
      height: 11,
      borderRadius: "100%",
      padding: 0,
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
        background: "none",
      },
    },
    statusChangeIconButton: {
      display: "none",
    },
    statusText: {
      marginLeft: theme.spacing(1),
    },
    statusContainer: {
      width: "100%",
    },
    customXeroToolbarComponent: {
      display: "flex",
      flexDirection: "row",
      justifyContent: SPACE_BETWEEN,
    },
    accordionHeaderContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: SPACE_BETWEEN,
      alignItems: "center",
      width: "100%",
    },
    generateText: {
      color: theme.palette.UI.secondary_rose,
    },
    filterLabel: {
      fontSize: "14px !important",
      color: theme.palette.text.placeholder_text,
      marginTop: theme.spacing(1),
    },
    chip: {
      marginTop: 0,
      background: "none",
      textTransfrom: "none",
      fontSize: "14px",
      color: theme.palette.UI.grey_700,
      marginLeft: -20,
      fontWeight: "normal",
    },

    fullChip: {
      color: theme.chip.text,
      fontSize: "12px",
      height: "24px",
      width: "auto",
      fontWeight: "normal",
      marginTop: 0,
      background: theme.chip.backgroundColor,
      "&:hover, &:focus": {
        backgroundColor: theme.chip.active.backgroundColor,
        boxShadow: "none",
      },
    },
    dataTableModalTitle: {
      fontSize: FONT_SIZE_16,
      color: theme.palette.UI.black,
      display: "inline",
    },
    tagsContainer: {
      marginTop: theme.spacing(1),
      marginBottom: 3,
      maxHeight: "105px",
      overflowY: "scroll",
    },
    quickFilterContainer: {
      width: "380px",
      maxWidth: "380px",
      height: "auto",
      marginBottom: "50px",
    },
    buttonsLayout: {
      justifyContent: SPACE_BETWEEN,
    },
    chipContent: {
      fontSize: "13px",
      cursor: "pointer",
      color: theme.palette.primary.main,
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
    list: {
      color: theme.palette.UI.grey_100,
    },
    hideBorder: {
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
    chipsContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "row",
      alignItems: "center",
    },
    ellipseChip: {
      color: theme.palette.UI.grey_700,
      width: "35px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    ellipseContainer: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "flex",
      flexDirection: "row",
    },
    btnContainer: {
      justifyContent: "center",
      display: "flex",
    },
    customHead: {
      fontWeight: 600,
      fontSize: "13px",
      color: theme.palette.UI.grey_900,
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
    customHeadDisable: {
      fontWeight: 600,
      fontSize: "13px",
      color: theme.palette.UI.grey_900,
      cursor: "pointer",
      whiteSpace: "nowrap",
      pointerEvents: "none",
    },
    toolTip: {
      backgroundColor: theme.palette.UI.grey_800,
      marginBottom: "0px !important",
    },
    displayText: {
      color: "#686868",
      fontSize: "13px",
      marginRight: "8px",
    },
    tableTitle: {
      marginLeft: -8,
    },
    customToolbar: {
      float: "right",
      marginRight: "10px",
    },
    line: {
      borderLeft: `1px solid ${theme.palette.UI.grey_100}`,
    },
    toolTipContainer: {
      padding: 0,
      "&:hover": {
        "& path": {
          fill: `${theme.palette.UI.purple}!important`,
        },
      },
    },
    infoIcon: {
      marginTop: -6,
      marginLeft: -6,
      padding: 3,
      "&:hover": {
        "& path": {
          fill: `${theme.palette.UI.purple}!important`,
        },
      },
    },
    toolTipText: {
      fontSize: 12,
    },
    emptyToolbar: {
      float: "right",
      display: "flex",
      marginRight: 16,
      marginTop: 3,
    },
    emptyToolbarText: {
      marginTop: "10px",
      float: "left",
      maxHeight: "42px",
    },
    emptyVerticalLine: {
      borderLeft: `1px solid ${theme.palette.UI.grey_100}`,
      height: 20,
      marginTop: 10,
    },
    addNewText: {
      fontSize: "13px",
      textTransform: "none",
      color: `${theme.link.color} !important`,
      backgroundColor: "transparent !important",
      paddingLeft: "5px",
      "&:hover": {
        backgroundColor: theme.palette.UI.white,
      },
    },
    enterpriseAddIcon: {
      width: "18px",
      height: "18px",
      marginTop: "2px",
    },
    separator: {
      borderLeft: `1px solid ${theme.palette.UI.grey_100}`,
      height: 20,
    },
    fullHeight: {
      height: "100%",
    },
    skeletonContainer: {
      marginTop: 5,
    },
    groupAccordionSkeleton: {
      marginTop: 8,
      marginBottom: 8,
      paddingLeft: 12,
      paddingRight: 12,
      borderRadius: 5,
    },
    statusChangeDialog: {
      "& .MuiDialog-container": {
        height: "64%",
      },
      "& .MuiPaper-root": {
        minHeight: "430px !important",
        position: "fixed",
        margin: "64px",
        top: "0px",
      },
    },
    statusChangeIcon: {
      marginTop: "50px",
    },
    statusChangeModalWrapper: {
      minWidth: "430px",
    },
    statusChangeDialogContent: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      padding: "0 15px",
    },
    statusChangeActionButtons: {
      marginBottom: "50px",
      "& button": {
        textTransform: "capitalize",
        fontWeight: 600,
      },
    },
    statusChangeBodyText: {
      display: "flex",
      textAlign: "center",
      flexDirection: "column",
      gap: "5px",
      fontSize: 13,
    },
    statusChangeInputWrapper: {
      margin: 0,
    },
    statusChangeButton: {
      marginRight: 8,
      marginLeft: 8,
      minWidth: "80px",
    },
    terminateTagLine: {
      display: "flex",
      fontSize: 13,
      "& svg": {
        fill: theme.palette.UI.red,
        fontSize: 18,
        marginRight: 5,
      },
    },
    info: {
      padding: 3,
      "& svg": {
        color: theme.palette.UI.blue_1000,
      },
    },
    blueText: {
      color: theme.palette.UI.blue_1000,
      fontSize: "11px",
    },
    purpleText: {
      color: theme.palette.UI.purple_900,
      fontSize: "11px",
    },
    AdminCrownIcon: {
      marginBottom: -1,
      stroke: theme.palette.UI.blue_1000,
      strokeWidth: 0.5,
    },
    ResellerCrownIcon: {
      marginBottom: -1,
      stroke: theme.palette.UI.purple_900,
      strokeWidth: 0.5,
    },
    executedMail: {
      fontWeight: 400,
      fontSize: "13px",
      lineHeight: "20px",
    },
    executedUser: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "22px",
    },
    centralize: {
      display: "flex",
      alignItems: "center",
      marginLeft: 16,
    },
    verticalDivider: {
      borderLeft: `1px solid ${theme.palette.UI.grey_100}`,
      marginLeft: 8,
      marginRight: 4,
    },
    whiteBackground: {
      backgroundColor: theme.palette.UI.white,
    },
    greyBackground: {
      backgroundColor: theme.palette.UI.grey,
    },
    hideSortFilter: {
      display: "none",
      pointerEvents: "none",
    },
    buttonAlignment: {
      display: "block",
      margin: "0 auto",
      textTransform: "none",
      marginTop: "15px",
      fontWeight: "500",
    },
    tableContainer: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "white",
    },
    reactTable: {
      borderCollapse: "separate",
      position: "relative",
      overflow: "auto",
    },
    reactTableHeader: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "white",
    },
    reactTableButton: {
      background: "none",
      border: "none",
    },
    trashButton: {
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "rgba(0, 0, 0, 0.54)",
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: "24px",
      "& p": {
        fontWeight: "400",
        fontSize: "0.875rem",
        lineHeight: "1.43",
        letterSpacing: "0.01071em",
        marginRight: "20px",
      },
    },
    multiSelectToolbar: {
      height: "auto !important",
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      backgroundColor: "#F2F2F2",
      padding: "16px 8px",
    },
    noMatchingRecords: {
      textAlign: "center",
    },
    reactTableRow: {
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    messageTooltip: {
      whiteSpace: "pre-line",
    },
    statusInfoIcon: {
      marginTop: -3,
      marginLeft: -6,
      padding: 3,
      "&:hover": {
        "& path": {
          fill: `${theme.palette.UI.purple}!important`,
        },
      },
    },
    pageNumber: {
      margin: "0 4px",
      cursor: "pointer",
      padding: "4px 12px",
      "&:hover": {
        color: "#FFFFFF!important",
        backgroundColor: "#1343D7",
        fontWeight: "bold!important",
      },
    },
    activePage: {
      fontWeight: "bold",
      textDecoration: "none",
      color: "#FFFFFF",
      backgroundColor: "#015C9F",
    },
    disabledDropdown: {
      color: theme.palette.UI.grey_500,
      border: `1px solid ${theme.palette.UI.grey_100}`,
      background: theme.palette.UI.grey_100,
      borderRadius: "4px",
    },
    menuDropDown: {
      maxHeight: "40%",
    },
    keyBoardButton: {
      color: "#686868",
      cursor: "pointer",
      backgroundColor: "transparent",
      border: "none",
      borderRadius: "2px",
      marginTop: "3px",
      padding: "4px",
      "&:hover": {
        backgroundColor: "#1343D7",
        color: "#FFFFFF",
      },
      "&:disabled": {
        backgroundColor: "transparent !important",
        color: "#E8E8E8",
        cursor: "default",
      },
    },
  };
});
